import React, { useEffect } from 'react'
import { ImageGalleryEditorProps } from './ImageGalleryEditor.types'
import styles from './ImageGalleryEditor.module.scss'
// import cl from 'classnames'
import { ToolPopupContainer } from '../ToolPopupContainer'
import { TabsLine } from '../TabsLine'
import { AspectTypes } from 'models'
import { Cropper } from './Cropper'
import { inject } from 'mobx-react'
import { IMAGE_EDITOR_STORE } from 'store'
import { observer } from 'mobx-react-lite'
import { GallerySection } from './GallerySection'
import { ImageUsageSection } from './ImageUsageSection'
import { handleImageVideoUrl } from 'utilities'

const ImageGalleryEditorComponent = (props: ImageGalleryEditorProps) => {
  const {
    className,
    style,
    [IMAGE_EDITOR_STORE]: {
      onImageGalleryEditorMount,
      onSelectedTabChange,
      onDoneClick,
      onCloseClick,
      selectedTab,
      selectedImage
    },
    ...rest
  } = props

  useEffect(() => {
    onImageGalleryEditorMount(rest)
    // eslint-disable-next-line
  }, [])

  return (
    <ToolPopupContainer
      className={className}
      style={style}
      title='Edit images'
      onClose={onCloseClick}
      bottomButtonsProps={[
        {
          children: 'Cancel',
          preset: 'secondary',
          onClick: onCloseClick
        },
        {
          children: 'Done',
          preset: 'primary',
          onClick: onDoneClick
        }
      ]}
    >
      <div className={styles.body}>
        <GallerySection />
        <div className={styles.imageEditor}>
          {handleImageVideoUrl(selectedImage?.url) && (
            <TabsLine<AspectTypes>
              tabs={Object.values(AspectTypes)}
              selectedTab={selectedTab}
              onSelectedTabChange={onSelectedTabChange}
              capitalizeTabs
              boldSelectedTab
            />
          )}
          {handleImageVideoUrl(selectedImage?.url) ? (
            <Cropper />
          ) : (
            <video key={selectedImage?.url} width='400' height='300' controls>
              <source src={selectedImage?.url as string} />
            </video>
          )}
        </div>
        <ImageUsageSection />
      </div>
    </ToolPopupContainer>
  )
}

const ImageGalleryEditor = inject(
  'IMAGE_EDITOR_STORE'
)(observer(ImageGalleryEditorComponent))
export { ImageGalleryEditor }
